import React, { Component } from "react"
import { Link, navigate } from "gatsby"
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import config from "../../../data/SiteConfig";

export default class MyNavbar extends Component {
  render() {
    return <>
<Navbar bg="light" expand="lg" fixed={this.props.fixed}>
  <Navbar.Brand onClick={()=>{navigate("/")}}>
  {config.siteTitle}
  </Navbar.Brand>
</Navbar>
    </>
  }
}
